module.exports = __webpack_public_path__ + "img/pordosol_landpage.9ddfe718.png";